import startCase from "lodash/startCase";
import kebabCase from "lodash/kebabCase";
import { camelizeKeys } from "@stadium/helpers/formatter";

import { ALL_TEMPLATES, MASTER_COMPANY_TYPENAME } from "@constants/templates-listing";

export const getCapitalisedSlug = (slug) => startCase(slug);

export const getFormattedSlug = (slug) => kebabCase(slug);

export const isMasterCompany = (type) => type === MASTER_COMPANY_TYPENAME;

export const getCategoryTitle = (title) =>
  title && title !== ALL_TEMPLATES ? `Choose a Template from ${title}` : "Choose a Template";

export const mapHitToFormattedData = (hit) => {
  const camelizedHit = camelizeKeys(hit);
  return {
    ...camelizedHit,
    data: camelizedHit?.topBannerImage,
    name: camelizedHit?.storeName,
    type: "image/jpeg",
  };
};

export const getSearchedTemplates = (searchedHits, stores) => {
  const publicShops = searchedHits ? searchedHits?.map(mapHitToFormattedData) : [];
  const privateShops = stores
    ? stores.map((item) => ({
        data: item?.topBanner,
        name: item?.name,
        ...item,
      }))
    : [];
  return privateShops.concat(publicShops);
};
